import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9244a750"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "principal" }
const _hoisted_2 = { class: "modal-content p-0" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "pagination col-md-6 col-sm-6 nav nav-tabs mt-2" }, null, -1))
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "d-flex row" }
const _hoisted_7 = { class: "col-sm-3 col-md-3 col-6 form-label" }
const _hoisted_8 = { class: "col-sm-3 col-md-3 col-6 form-label" }
const _hoisted_9 = { class: "col-sm-3 col-md-3 col-6 form-label" }
const _hoisted_10 = { class: "col-sm-3 col-md-3 col-6 form-label" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "d-flex row" }
const _hoisted_13 = { class: "col-sm-12 col-md-12 form-label" }
const _hoisted_14 = { class: "input-group col-sm-12 col-md-12" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "col-sm-12 col-md-12 form-label" }
const _hoisted_17 = { class: "input-group col-sm-12 col-md-12" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "d-flex row" }
const _hoisted_20 = { class: "col-sm-12 col-md-12 form-label" }
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = {
  key: 0,
  type: "text",
  class: "form-control",
  id: "inputGroupFile02",
  disabled: "",
  placeholder: "Não possui Prof. Executante"
}
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "col-sm-12 col-md-12 form-label" }
const _hoisted_25 = { class: "input-group" }
const _hoisted_26 = {
  key: 0,
  type: "text",
  class: "form-control",
  id: "inputGroupFile02",
  disabled: "",
  placeholder: "Não possui Prof. Solicitante"
}
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "col-sm-6 col-md-6 form-label" }
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  key: 0,
  class: "col-sm-6 col-md-6 form-label"
}
const _hoisted_31 = ["value"]
const _hoisted_32 = {
  key: 1,
  type: "text",
  class: "form-control",
  id: "inputGroupFile02",
  disabled: "",
  value: 'Sala não cadastrada'
}
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-12 col-sm-12" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1" }, "Procedimentos", -1))
const _hoisted_36 = { class: "tamanho" }
const _hoisted_37 = ["value"]
const _hoisted_38 = {
  class: "modal-backdrop fade show",
  id: "backdrop"
}

import { TipoMensagem } from '@/consts/consts';
import mensagem from '@/hooks/mensagem';
import AgendaProfissional from '@/model/AgendaProfissional';
import Convenio from '@/model/Convenio';
import Paciente from '@/model/Paciente';
import Procedimento from '@/model/Procedimento';
import Profissional from '@/model/Profissional';
import services from '@/services';
import moment from 'moment';
import { onMounted, reactive } from 'vue';
import config from '@/config/config.json';
// import ModalPesqDorape from './ModalPesqDorape.vue';
// import { mask } from 'vue-the-mask';
// import api from '@/api/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'Atendimento',
  props: ["visiblePesq", "width", "height", "atendimento", "agenda", "agendaLancar", "tabelaConvenio", "convenio",
	"visivel", "lancamento", "existeAgenda", "retornaAtendimento", "nomePaciente", "atendGerado",
	"lstQtde", "camposDesabilitados", "agendando"],
  emits: ["atendResult", "paginacao"],
  setup(__props, { emit }) {

const props = __props;




const state = reactive({
	lstPosicaoValue: ["AB", "CA"],
	lstPosicaoTexto: ["Aberto", "Cancelado"],
	lstRevisaoValue: ["S", "N"],
	lstRevisaoTexto: ["Sim", "Não"],
	lstDescontoValue: ["P", "V"],
	lstDescontoTexto: ["Porcentagem", "Valor"],
	lstTipoAtendTexto: Array<object>() as any,
	lstProcedimentoMostrar: Array<Procedimento>(),
	lstQtdeMostrar: Array<number>(),

	atendimento: {
		id: Number(),
		dtInclusao: new Date(),
		dtAlteracao: new Date(),
		hora: String(),
		idAgendamento: Number(),
		dtAgenda: String(),
		paciente: Paciente,
		convenio: Convenio,
		posicaoAtend: "AB" || String(),
		usuario: String(),
		usuarioUpdate: String(),
		usuarioCancelamento: String(),
		revisao: String(),
		retorno24h: String(),
		valorPagMedico: Number(),
		valorPendencia: Number(),
		statusPendencia: String(),
		idProfExec: Number(0),
		idProfSolic: Number(0),
		idTipoAtend: null,
		urgencia: Boolean(),
		total: Number(),
		desconto: Number(),
		tipoDesconto: "P" || String(),
		totalAcrescDesc: Number(),
		idCliente: Number()
	},
	agenda: {
		item: Number(),
		dia: String(),
		hora: String(),
		agendado: Boolean(),
		idAgenda: Number(),
		status: Boolean(),
		statusDescricao: String(),
		nomePaciente: String(),
		nomeProfissional: String()
	},
	paciente: Object() as Paciente,
	profissional: Object() as Profissional,
	convenio: Object() as Convenio,
	procedimento: Object() as Procedimento,
	agendaLancar: Object() as any,
	config: Object() as any,

	pacienteCadastrado: Boolean(true),
	habilitarLinhas: Boolean(),
	ativarPesquisaConvenio: Boolean(),
	ativarPesquisaPaciente: Boolean(),
	ativarPesquisaProfissionalExec: Boolean(),
	ativarPesquisaProfissionalSolic: Boolean(),
	ativarPesquisaProcedimento: Boolean(),
	mostrarPrincipal: Boolean(true),
	mostrarProcedimentos: Boolean(),
	temErro: Boolean(),

	nomePaciente: String(),
	nomeConvenio: String(),
	nomeProfExec: String(),
	nomeProfSolic: String(),
	tituloErro: "Erro",
	erro: String(),

	tabelaConvenio: Number(),
	valor: Number(0),
	valorPendencia: Number(),
	valorDescAcresc: Number(0),
	valorFinal: Number(),
	valorDescAcrescAntigo: Number(),
	valorPendenciaAntigo: Number(),
	tipoDesc: Number(1),
	tipoDescAntigo: Number(),
});

// function pesquisaVisivelPaciente() {
// 	state.ativarPesquisaPaciente = true;
// }
// function modalPesqResultPaciente(result: string, obj: Paciente) {
// 	if (result === "ok") {
// 		state.paciente = obj;
// 		state.nomePaciente = obj.nomeSocial;
// 	}
// 	state.ativarPesquisaPaciente = false;
// }

// function pesquisaVisivelConvenio() {
// 	state.ativarPesquisaConvenio = true;
// }
// function modalPesqResultConvenio(result: string, obj: Convenio) {
// 	if (result === "ok") {
// 		state.convenio = obj;
// 		state.nomeConvenio = obj.descricao;
// 	}
// 	state.ativarPesquisaConvenio = false;
// }

// function pesquisaVisivelProfExecutante() {
// 	state.ativarPesquisaProfissionalExec = true;
// }
// function modalPesqResultProfissionalExec(result: string, obj: Profissional) {
// 	if (result === "ok") {
// 		state.nomeProfExec = obj.nome;
// 		state.atendimento.idProfExec = obj.id;
// 	}
// 	state.ativarPesquisaProfissionalExec = false;
// }

// function pesquisaVisivelProfSolicitante() {
// 	state.ativarPesquisaProfissionalSolic = true;
// }
// function modalPesqResultProfissionalSolic(result: string, obj: Profissional) {
// 	if (result === "ok") {
// 		state.nomeProfSolic = obj.nome;
// 		state.atendimento.idProfSolic = obj.id;
// 	}
// 	state.ativarPesquisaProfissionalSolic = false;
// }

// function pesquisaVisivelProcedimento() {
// 	state.ativarPesquisaProcedimento = true;
// }
// async function modalPesqResultProcedimento(result: string, obj: Procedimento) {
// 	if (result === "ok") {
// 		state.lstProcedimentoAdd.push(obj);
// 		// const { data, erros } = await services.agendaProcedimento.ProcedimentoValor(obj.codigo, state.convenio.id);
// 		// if (!erros) {
// 		state.lstQtdeAdd.push(1);
// 		// }
// 	}
// 	state.ativarPesquisaProcedimento = false;
// }

function paginacao(pagina: number) {
	switch (pagina) {
		case 1:
			state.mostrarPrincipal = true;
			state.mostrarProcedimentos = false;
			break;
		case 2:
			if (state.convenio.id > 0) {
				state.mostrarPrincipal = false;
				state.mostrarProcedimentos = true;
			} else {
				const msg = mensagem();
				msg.InserirMensagem('Atenção', "Informe o Convenio", TipoMensagem.Alert);
			}
			break;
	}
}

// function enviar() {
// 	const msg = mensagem();
// 	state.atendimento.hora = state.agenda.hora;

// 	if (!state.paciente) {
// 		msg.InserirMensagem('Alerta', "Selecione um paciente", TipoMensagem.Alert);
// 		return;
// 	}

// 	if (!state.convenio) {
// 		msg.InserirMensagem('Alerta', "Selecione um convenio", TipoMensagem.Alert);
// 		return;
// 	}

// 	if (state.lstProcedimentoAdd) {
// 		let lstProcAux = state.lstProcedimentoAdd;
// 		state.lstProcedimentoMostrar.forEach((l: any, index: number) => {
// 			lstProcAux.push(l);
// 		});

// 		let lstQtdeAux = state.lstQtdeAdd;
// 		state.lstQtdeMostrar.forEach((l: any, index: number) => {
// 			lstQtdeAux.push(l);
// 		});

// 		if (state.atendimento.id > 0) {
// 			emit("atendResult", state.atendimento, false, false, lstProcAux, lstQtdeAux);
// 		} else {
// 			emit("atendResult", state.atendimento, false, true, lstProcAux, lstQtdeAux);
// 		}
// 	} else {
// 		msg.InserirMensagem('Alerta', "Informe um procedimento", TipoMensagem.Alert);
// 	}

// 	resetarListas();
// }

function cancelar() {
	emit("atendResult", null, true, false, null, null, "cancel");
	resetarListas();
}

function resetarListas() {
	state.lstProcedimentoMostrar = [];
	state.lstProcedimentoMostrar.pop();
}

async function iniciarListaAgenda(pId: number) {
	setTimeout(async () => {
		resetarListas();
		if (props.lancamento) {
			await services.atendProcedimento.ListarPorId(state.atendimento.id)
				.then(resp => {
					state.lstQtdeMostrar = [];
					resp.data.forEach(async (r: Record<string, any>) => {
						const { data, erros } = await services.procedimento.ListarPorId(r.idProcedimento);
						if (!erros) {
							state.lstProcedimentoMostrar.push(data);
							state.lstQtdeMostrar.push(r.qtde);
						}
					});
				});
		} else {
			await services.agendaProcedimento.ListarPorId(pId)
				.then(resp => {
					resp.data.forEach((r: Record<string, any>) => {
						state.lstProcedimentoMostrar.push(r.procedimento);
					});
				});
		}
	}, 500);
}

onMounted(async () => {
	resetarListas();
	state.lstQtdeMostrar.pop();
	state.agenda = props.agenda;
	state.atendimento = props.atendimento;
	state.agendaLancar = props.agendaLancar;
	// console.log(state.agendaLancar);
	state.nomePaciente = props.atendimento.paciente.nome;
	state.nomeConvenio = props.atendimento.convenio.descricao;
	state.tabelaConvenio = props.tabelaConvenio;
	state.convenio = props.convenio;
	(props.lstQtde) ? state.lstQtdeMostrar = props.lstQtde : "";
	// console.log(props.agenda);
	// console.log(props.atendimento);
	// console.log(props.agendaLancar);
	// console.log(props.atendimento);
	// console.log(props.tabelaConvenio);
	// console.log(props.convenio);
	iniciarListaAgenda(Number(state.atendimento.idAgendamento));
	// console.log("teste");
	state.atendimento.dtAgenda = moment(state.atendimento.dtAgenda).format("YYYY-MM-DD");
	let data, sql = "";
	if (state.atendimento.idProfExec) {
		sql += `SELECT P.NOME FROM PROFISSIONAL P WHERE P.ID = ${state.atendimento.idProfExec}`;
		data = await services.relatorio.ListarSql(sql);
		state.nomeProfExec = data?.data;
	}
	if (state.atendimento.idProfSolic) {
		sql += `SELECT P.NOME FROM PROFISSIONAL P WHERE P.ID = ${state.atendimento.idProfSolic}`;
		data = await services.relatorio.ListarSql(sql);
		state.nomeProfSolic = data?.data;
	}

	(window.outerWidth < 1000) ? state.habilitarLinhas = true : "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["", { 'modal fade show': __props.visivel }]),
        "data-bs-keyboard": "false",
        tabindex: "-1",
        style: {"display":"block"},
        id: "Principal"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal-dialog-centered", { 'modal-dialog': __props.visivel }]),
          style: _normalizeStyle({ 'minWidth': __props.width, 'height': __props.height })
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _withDirectives(_createElementVNode("button", {
                type: "button",
                class: "btn-close col-md-1",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelar()))
              }, null, 512), [
                [_vShow, __props.visivel]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, [
                  _createTextVNode("Código "),
                  (state.agendaLancar.idAtendimento <= 0)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "form-control",
                        type: "text",
                        disabled: "",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.agendaLancar.id) = $event))
                      }, null, 512)), [
                        [_vModelText, state.agendaLancar.id]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        class: "form-control",
                        type: "text",
                        disabled: "",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.agendaLancar.idAtendimento) = $event))
                      }, null, 512)), [
                        [_vModelText, state.agendaLancar.idAtendimento]
                      ])
                ]),
                _createElementVNode("label", _hoisted_8, [
                  _createTextVNode("Data Agenda "),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "date",
                    disabled: "",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.atendimento.dtAgenda) = $event))
                  }, null, 512), [
                    [_vModelText, state.atendimento.dtAgenda]
                  ])
                ]),
                _createElementVNode("label", _hoisted_9, [
                  _createTextVNode("Hora "),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "time",
                    disabled: "",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.agenda.hora) = $event))
                  }, null, 512), [
                    [_vModelText, state.agenda.hora]
                  ])
                ]),
                _createElementVNode("label", _hoisted_10, [
                  _createTextVNode("Revisão "),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.atendimento['revisao']) = $event)),
                    disabled: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.lstRevisaoValue, (l, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: l
                      }, _toDisplayString(state.lstRevisaoTexto[index]), 9, _hoisted_11))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, state.atendimento['revisao']]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, [
                  _createTextVNode("Paciente "),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "inputGroupFile02",
                      disabled: "",
                      value: (state.nomePaciente ?? __props.nomePaciente)
                    }, null, 8, _hoisted_15)
                  ])
                ]),
                _createElementVNode("label", _hoisted_16, [
                  _createTextVNode("Convênio "),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "inputGroupFile02",
                      disabled: "",
                      value: state.nomeConvenio
                    }, null, 8, _hoisted_18)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, [
                  _createTextVNode("Profissional Executante "),
                  _createElementVNode("div", _hoisted_21, [
                    (state.atendimento['idProfExec'] == 0)
                      ? (_openBlock(), _createElementBlock("input", _hoisted_22))
                      : (_openBlock(), _createElementBlock("input", {
                          key: 1,
                          type: "text",
                          class: "form-control",
                          id: "inputGroupFile02",
                          disabled: "",
                          placeholder: "Não possui Prof. Executante",
                          value: `${state.atendimento['idProfExec']}  ${'|| ' + state.nomeProfExec}`
                        }, null, 8, _hoisted_23))
                  ])
                ]),
                _createElementVNode("label", _hoisted_24, [
                  _createTextVNode("Profissional Solicitante "),
                  _createElementVNode("div", _hoisted_25, [
                    (state.atendimento['idProfSolic'] == null)
                      ? (_openBlock(), _createElementBlock("input", _hoisted_26))
                      : (_openBlock(), _createElementBlock("input", {
                          key: 1,
                          type: "text",
                          class: "form-control",
                          id: "inputGroupFile02",
                          disabled: "",
                          placeholder: "Não possui Prof. Solicitante",
                          value: `${state.atendimento['idProfSolic']}  ${'|| ' + state.nomeProfSolic}`
                        }, null, 8, _hoisted_27))
                  ])
                ]),
                _createElementVNode("label", _hoisted_28, [
                  _createTextVNode("Tipo Atendimento "),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((state.atendimento.idTipoAtend) = $event)),
                    disabled: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.lstTipoAtendTexto, (l, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: l.id
                      }, _toDisplayString(l.descricao), 9, _hoisted_29))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, state.atendimento.idTipoAtend]
                  ])
                ]),
                (_unref(config).mostrarSala)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_30, [
                      _createTextVNode("Sala "),
                      (props.agenda.sala?.length > 1)
                        ? (_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "text",
                            class: "form-control",
                            id: "inputGroupFile02",
                            disabled: "",
                            value: props.agenda.sala
                          }, null, 8, _hoisted_31))
                        : (_openBlock(), _createElementBlock("input", _hoisted_32))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("label", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.lstProcedimentoMostrar, (l, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "input-group mb-1",
                        key: index
                      }, [
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "inputGroupFile02",
                          disabled: "",
                          value: l?.descricao
                        }, null, 8, _hoisted_37)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ], 6)
      ], 2), [
        [_vShow, __props.visiblePesq === true && state.mostrarPrincipal === true]
      ])
    ], 512), [
      [_vShow, __props.visiblePesq]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_38, null, 512), [
      [_vShow, (__props.visiblePesq)]
    ])
  ], 64))
}
}

})